<div class="fixed top-0 left-0 right-0 z-50">
  <mat-progress-bar aria-label="progress bar" color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
</div>
<router-outlet></router-outlet>
